module.exports = __webpack_public_path__ + "media/images/loterija-bc3be354.svg";